export enum ReservationDetailTypeDetail {
    Aucun = "",
    Automatique = "AU",
    Manuel = "MA",
    Effacer = "EF",
    Modifier = "MO"
}